// Web-only Socket.IO handoff. Buffer only new emits after the server offer;
// never replay packets that were already sent to the old generation.
function attachSocketDeploymentMigration(socket) {
  const originalEmit = socket.emit;
  let offer = null, holding = false, disposed = false;
  const queued = [];
  const flush = () => {
    holding = false;
    while (queued.length && !disposed) {
      const { args, flags } = queued.shift();
      socket.flags = flags;
      originalEmit.apply(socket, args);
    }
  };
  const emit = function (...args) {
    if (!holding || ['connect', 'connect_error', 'disconnect', 'disconnecting', 'newListener', 'removeListener'].includes(args[0])) {
      return originalEmit.apply(this, args);
    }
    // Socket.IO's one-shot modifiers must stay attached to their own packet.
    queued.push({ args, flags: { ...socket.flags } });
    socket.flags = {};
    return this;
  };
  socket.emit = emit;
  const prepare = (message, acknowledge) => {
    const id = message?.id;
    if (typeof acknowledge !== 'function') return;
    if (typeof id !== 'string' || !/^[a-f0-9-]{36}$/.test(id) || offer || !socket.connected
        || Object.keys(socket.acks || {}).length || socket.sendBuffer?.length) {
      acknowledge({ id, ready: false }); return;
    }
    offer = id; holding = true;
    acknowledge({ id, ready: true });
  };
  const cancel = message => {
    if (!offer || message?.id !== offer) return;
    offer = null; flush();
  };
  const commit = message => {
    if (!offer || message?.id !== offer) return;
    offer = null;
    // Explicit reconnect re-evaluates auth and creates a new Engine.IO ID.
    // Existing connect handlers restore room subscriptions and missed history.
    socket.disconnect(); socket.connect();
  };
  const disconnected = () => { if (holding) offer = null; };
  const connected = () => { offer = null; flush(); };
  socket.on('deployment:prepare', prepare);
  socket.on('deployment:cancel', cancel);
  socket.on('deployment:commit', commit);
  socket.on('disconnect', disconnected);
  socket.on('connect', connected);
  return () => {
    disposed = true; queued.length = 0;
    if (socket.emit === emit) socket.emit = originalEmit;
    for (const [name, handler] of [['deployment:prepare', prepare], ['deployment:cancel', cancel],
      ['deployment:commit', commit], ['disconnect', disconnected], ['connect', connected]]) socket.off(name, handler);
  };
}
module.exports = { attachSocketDeploymentMigration };
